import { render, staticRenderFns } from "./newBookingExcel.vue?vue&type=template&id=287d489f&scoped=true"
import script from "./newBookingExcel.vue?vue&type=script&lang=js"
export * from "./newBookingExcel.vue?vue&type=script&lang=js"
import style0 from "./newBookingExcel.vue?vue&type=style&index=0&id=287d489f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287d489f",
  null
  
)

export default component.exports